<template>
  <div :class="['audio-wrapper audio-widget', isAudioOpen ? 'opened' : 'closed']">
    <loading-icon v-if="loading" v-show="isAudioOpen"></loading-icon>
    <div class="audio-section">
      <audio-upload
          v-show="!loading && isAudioOpen"
          v-if="!audioMedia"
          :attachmentOwner="messageType"
          :attachmentOwnerId="messageId"
          :attachmentUrl="attachmentUrl"
          :maxMediaSize="maxMediaSize"
          @setLoading="setLoading"
          @uploadMediaAttachment="uploadMediaAttachment"></audio-upload>

      <small v-if="errorMessage" class="error-label">{{errorMessage}}</small>

      <media-playback
          v-if="audioMedia && !loading && messageIsVisible"
          :attachedMedia="audioMedia"
          :attachmentOwnerId="messageId"
          :isAudioOpen="isAudioOpen"
          :loading="loading && !errorMessage"
          @setLoading="setLoading"></media-playback>

      <sms-action-footer @closeAction="$emit('closeAudio', 'audio', true)">
        <p v-if="audioMedia" slot="footerRight" @click="deleteMediaAttachment">remove</p>
      </sms-action-footer>
    </div>
  </div>
</template>

<script>
  import AudioUpload from './AudioUpload'
  import CreateAttachmentMixin from '../../mixins/CreateAttachmentMixin'
  import { mapState } from 'vuex'
  import MediaPlayback from './MediaPlayback'
  import LoadingIcon from '../shared/LoadingIcon'
  import SmsActionFooter from '../Sms/SmsActionFooter'

  export default {
    props: {
      activeMessage: Boolean,
      attachmentUrl: String,
      isAudioOpen: Boolean,
      messageModuleName: String,
    },

    name: 'AudioAttachment',

    components: {
      AudioUpload,
      MediaPlayback,
      LoadingIcon,
      SmsActionFooter,
    },

    mixins: [CreateAttachmentMixin],

    data() {
      return {
        errorMessage: null,
        loading: false,
        mediaUrl: null,
      }
    },

    methods: {
      configureCreatedAudio(data, errors) {
        if (data && !errors) {
          this.$emit('getAttachedMedia')
          this.errorMessage = null
        } else if (errors) {
          this.errorMessage = `issue uploading audio file: ${errors}`
        } else {
          this.errorMessage = 'error uploading audio file, no data found'
        }
      },

      deleteMediaAttachment() {
        this.loading = true
        this.audioMedia && this.$emit('removeMediaAttachment', this.audioMedia.uuid)
      },

      setAttachmentErrors(errorObj) {
        this.loading = false
        this.errorMessage = !!errorObj ? `issue with media file: ${errorObj}` : null
      },

      setLoading(isLoading) {
        this.loading = isLoading
      },

      uploadMediaAttachment(file, filename) {
        this.loading = true
        this.errorMessage = null

        if (file && file.size < this.maxMediaSize) {
          let formData = new FormData()
          formData.append('file', file, `${filename}.mp4`)
          formData.append('label', 'audio')
          formData.append('owner_type', this.messageType)
          formData.append('owner_id', this.messageId)
          this.createAttachment(formData, this.configureCreatedAudio, this.setAttachmentErrors)
        } else {
          this.errorMessage = 'media file is too large, select a media file under 5mb'
        }
      },

    },

    computed: {
      audioMedia: function () {
        return this.audios[0] || null
      },

      messageIsVisible: function () {
        return this.messageType === 'AutoCampaignMessage' ? this.activeMessage : true
      },

      ...mapState({
        audios (state, getters) {
          return getters[`${this.messageModuleName}/audios`]
        },
        maxMediaSize (state) {
          return state.maxMediaSize
        },
        messageId (state) {
          return state[this.messageModuleName]?.messageId
        },
        messageType (state) {
          return state[this.messageModuleName]?.messageType
        },
      })
    },

    watch: {
      audioMedia: function () {
        this.loading = false
        this.mediaUrl = this.audioMedia?.url
      },

      loading: function () {
        this.$emit('setMediaLoading', 'audio', this.loading)
      }
    },
  }
</script>